/**
 * Endpoints para conceptos de nómina y ajustes de contrato
 */

import { GET, POST, PUT, DELETE } from "../config";

/**
 * Obtener todos los conceptos de nómina
 */
export const getPayrollConcepts = async (params = {}) => {
  const response = await GET("/employees/payroll-concepts/", { params });
  return response.data;
};

/**
 * Obtener solo conceptos de tipo BONO
 */
export const getBonusConcepts = async () => {
  const response = await GET("/employees/payroll-concepts/bonuses/");
  return response.data;
};

/**
 * Obtener solo conceptos de tipo DESCUENTO
 */
export const getDeductionConcepts = async () => {
  const response = await GET("/employees/payroll-concepts/deductions/");
  return response.data;
};

/**
 * Crear un nuevo concepto de nómina
 */
export const createPayrollConcept = async (data) => {
  const response = await POST("/employees/payroll-concepts/", data);
  return response.data;
};

/**
 * Actualizar un concepto de nómina
 */
export const updatePayrollConcept = async (id, data) => {
  const response = await PUT(`/employees/payroll-concepts/${id}/`, data);
  return response.data;
};

/**
 * Eliminar un concepto de nómina
 */
export const deletePayrollConcept = async (id) => {
  await DELETE(`/employees/payroll-concepts/${id}/`);
};

/**
 * Obtener todos los ajustes de contrato
 */
export const getContractAdjustments = async (params = {}) => {
  const response = await GET("/employees/contract-adjustments/", { params });
  return response.data;
};

/**
 * Obtener ajustes de un empleado específico
 */
export const getContractAdjustmentsByEmployee = async (employeeId) => {
  const response = await GET("/employees/contract-adjustments/by_employee/", {
    params: { employee: employeeId },
  });
  return response.data;
};

/**
 * Crear un nuevo ajuste de contrato
 */
export const createContractAdjustment = async (data) => {
  const response = await POST("/employees/contract-adjustments/", data);
  return response.data;
};

/**
 * Actualizar un ajuste de contrato
 */
export const updateContractAdjustment = async (id, data) => {
  const response = await PUT(`/employees/contract-adjustments/${id}/`, data);
  return response.data;
};

/**
 * Eliminar un ajuste de contrato
 */
export const deleteContractAdjustment = async (id) => {
  await DELETE(`/employees/contract-adjustments/${id}/`);
};

/**
 * Pausar un ajuste de contrato
 */
export const pauseContractAdjustment = async (id) => {
  const response = await POST(`/employees/contract-adjustments/${id}/pause/`);
  return response.data;
};

/**
 * Reactivar un ajuste de contrato
 */
export const resumeContractAdjustment = async (id) => {
  const response = await POST(`/employees/contract-adjustments/${id}/resume/`);
  return response.data;
};

/**
 * Aplicar bonos a una entrada de nómina
 */
export const applyBonusesToEntry = async (entryId, bonuses) => {
  const response = await POST(
    `/employees/payroll-entries/${entryId}/apply_bonuses/`,
    { bonuses }
  );
  return response.data;
};

/**
 * Aplicar descuentos a una entrada de nómina
 */
export const applyDeductionsToEntry = async (entryId, deductions) => {
  const response = await POST(
    `/employees/payroll-entries/${entryId}/apply_deductions/`,
    { deductions }
  );
  return response.data;
};
